import React, { useState } from "react";
import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc } from "firebase/firestore";
import '../assets/styles/Form.scss';
import config from "../config/firebase";

const app = initializeApp({
    apiKey: config.firebaseConfig.apiKey,
    authDomain: config.firebaseConfig.authDomain,
    projectId: config.firebaseConfig.projectId
});

const db = getFirestore(app);

function Form() {
    const [fields, setFields] = useState({
        name: '',
        email: '',
        cname: '',
        pnum: '',
        comments: '',
        hp: ''
    });
    const [success, setSuccess] = useState(false);

    function handleChange(e) {
        const { name, value } = e.target;
        setFields(prev => ({ ...prev, [name]: value }));
    }

    async function handleSubmit(e) {
        e.preventDefault();
        if (fields.hp === '') {
            try {
                const docRef = await addDoc(collection(db, "contacts"), {
                    name: fields.name,
                    email: fields.email,
                    pnum: fields.pnum,
                    cname: fields.cname,
                    comments: fields.comments
                });
                console.log("Document written with ID: ", docRef.id);
                setSuccess(true);
                setTimeout(() => { window.location.href = "/" }, 4000);
            } catch (error) {
                console.error("Error adding document: ", error);
            }
        } else {
            setSuccess(true);
            setTimeout(() => { window.location.href = "/" }, 4000);
        }
    }

    return (
        <div className="form-container">
        <form className="contact-form" onSubmit={handleSubmit}>
            <label><span>Full Name:</span>
                <input className="input" name="name" type="text" required placeholder="Full Name" onChange={handleChange} value={fields.name} />
            </label>

            <label><span>Email:</span>
                <input className="input" name="email" type="email" required placeholder="Email" onChange={handleChange} value={fields.email} />
            </label>

            <label><span>Company Name:</span>
                <input className="input" name="cname" type="text" required placeholder="Company Name" onChange={handleChange} value={fields.cname} />
            </label>

            <label><span>Phone Number:</span>
                <input className="input" name="pnum" type="tel" required placeholder="Phone Number" onChange={handleChange} value={fields.pnum} />
            </label>

            <label className="hp">
                <input className="input" tabIndex="-1" name="hp" onChange={handleChange} value={fields.hp} type="text" />
            </label>

            <label><span>Comments:</span>
                <textarea className="textarea" name="comments" onChange={handleChange} value={fields.comments} id="comments" placeholder="Comments" />
            </label>

            <input className="submit" type="submit" value="Inquire" />
            <div className={`success${success ? ' show' : ''}`}>
                Thanks for your inquiry, someone will get back to you shortly.
            </div>
        </form>
        <div className="grid grid-12 text-center"><p>Contact us at <a href="tel:17782372572">1 778-237- 2572</a></p><p>Nivesh Sharma, General Manager<br/>12414 - 82 Ave Unit#104, Surrey, BC V3W 3E9</p></div>
</div>
    );
}

export default Form;